// extracted by mini-css-extract-plugin
module.exports = {"departments":"in-z","departmentHeading":"jn-z","departmentSection":"kn-z","departmentName":"ln-z","departmentLink":"mn-z","expandIcon":"nn-z"};